import PropTypes from "prop-types";

/**
 * @param {string} className
 * @param {string} width
 * @param {string} height
 * @param {string} fill
 * @param {string} stroke
 * @returns {JSX.Element}
 * @constructor
 */
export default function Chevron({ className, height = '8', width = '14', fill = 'none', stroke = 'black' }) {
    return (
        <svg className={className} width={width} height={height} viewBox="0 0 14 8" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M1 7L7 1L13 7" stroke={stroke} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

Chevron.PropTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    stroke: PropTypes.string,
    className: PropTypes.string,
}
